import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Button, Popup } from 'semantic-ui-react';
import { DEFAULT_SHARE_ICON, DEFAULT_SUCCESS_MESSAGE, DEFAULT_FAILURE_MESSAGE, FEEDBACK_POPUP_DURATION, FEEDBACK_POPUP_CLASS } from './ShareButton.constants';
import { MessagesPropType } from './ShareButton.propTypes';
import { classNames } from '../../../../utils/classname';
import Icon from '../../../foundation/components/Icon';
var defaultProps = {
  iconName: DEFAULT_SHARE_ICON,
  label: '',
  messages: {
    success: DEFAULT_SUCCESS_MESSAGE,
    failure: DEFAULT_FAILURE_MESSAGE
  }
};
function Share(_ref) {
  var _classNames;
  var iconName = _ref.iconName,
    label = _ref.label,
    onShare = _ref.onShare,
    messages = _ref.messages;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayFeedback = _useState2[0],
    setDisplayFeedback = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    feedbackSuccess = _useState4[0],
    setFeedbackSuccess = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    timeoutId = _useState6[0],
    setTimeoutId = _useState6[1];
  var successMessage = messages.success,
    failureMessage = messages.failure;
  function onClick(_x) {
    return _onClick.apply(this, arguments);
  }
  function _onClick() {
    _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return onShare(e);
          case 3:
            setFeedbackSuccess(true);
            _context.next = 9;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            setFeedbackSuccess(false);
          case 9:
            setDisplayFeedback(true);
            if (timeoutId) {
              clearTimeout(timeoutId);
            }
            setTimeoutId(setTimeout(function () {
              return setDisplayFeedback(false);
            }, FEEDBACK_POPUP_DURATION));
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return _onClick.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Popup, {
    open: displayFeedback,
    content: feedbackSuccess ? successMessage : failureMessage,
    position: "bottom center",
    className: classNames((_classNames = {}, _defineProperty(_classNames, FEEDBACK_POPUP_CLASS, true), _defineProperty(_classNames, "error", !feedbackSuccess), _classNames)),
    offset: [0, 10],
    trigger: /*#__PURE__*/React.createElement(Button, {
      onClick: onClick,
      className: "catalog-item-share-container",
      "aria-label": "Share"
    }, iconName && /*#__PURE__*/React.createElement(Icon, {
      iconName: iconName
    }), label && /*#__PURE__*/React.createElement(React.Fragment, null, label))
  });
}
Share.defaultProps = defaultProps;
export default Share;